import {
  LayoutDashboard, Users, Wallet, Building2, Gift, CalendarCheck, HandCoins,
  BadgePercent, Calculator, History, CreditCard, ReceiptText, FileSpreadsheet,
  FolderKanban, ClipboardList, Clock, PiggyBank, UserCog, ScrollText, Settings, Timer,
  ShoppingCart, Coins, FileCheck, UserCheck, CarFront, BarChart3,
} from "lucide-react";

// roles: [] = semua role boleh. super_admin selalu boleh (lihat canAccess)
// Catatan: HR hanya kelola Data Karyawan, Absensi, & Proyek (tanpa modul uang/angka).
export const NAV = [
  {
    title: "UTAMA",
    items: [{ to: "/", label: "Dashboard", icon: LayoutDashboard, roles: ["direktur", "finance", "viewer"] }],
  },
  {
    title: "MASTER DATA",
    items: [
      { to: "/employees", label: "Data Karyawan", icon: Users, roles: ["hr", "finance", "direktur", "site_admin"] },
      { to: "/salary-rates", label: "Master Gaji", icon: Wallet, roles: ["finance", "direktur"] },
      { to: "/projects", label: "Data Proyek", icon: Building2, roles: ["hr", "finance", "direktur"] },
      { to: "/allowance-types", label: "Jenis Tunjangan & Potongan", icon: Gift, roles: ["finance", "direktur"] },
    ],
  },
  {
    title: "TRANSAKSI HARIAN",
    items: [
      { to: "/attendance", label: "Absensi Cepat", icon: CalendarCheck, roles: ["hr", "site_admin", "direktur"] },
      { to: "/cash-advances", label: "Kasbon / Pinjaman", icon: HandCoins, roles: ["finance", "direktur"] },
      { to: "/kasbon-requests", label: "Pengajuan Kasbon", icon: FileCheck, roles: ["site_admin", "finance", "direktur", "hr"] },
      { to: "/allowances", label: "Tunjangan", icon: BadgePercent, roles: ["direktur"] },
      { to: "/deductions", label: "Potongan Gaji", icon: BadgePercent, roles: ["direktur"] },
    ],
  },
  {
    title: "PENGGAJIAN",
    items: [
      { to: "/payroll", label: "Proses Penggajian", icon: Calculator, roles: ["finance", "direktur"] },
      { to: "/payroll-history", label: "Riwayat & Lock", icon: History, roles: ["finance", "direktur"] },
      { to: "/payments", label: "Pembayaran", icon: CreditCard, roles: ["finance", "direktur"] },
      { to: "/payslips", label: "Slip Gaji", icon: ReceiptText, roles: ["finance", "direktur"] },
    ],
  },
  {
    title: "LAPORAN",
    items: [
      { to: "/reports/attendance-realtime", label: "Rekap Absensi (Realtime)", icon: Timer, roles: ["direktur", "finance", "site_admin", "viewer"] },
      { to: "/reports/attendance-range", label: "Rekap Absensi (Rentang)", icon: ClipboardList, roles: ["direktur", "finance", "site_admin", "viewer"] },
      { to: "/reports/mandor-check", label: "Cek Absen Mandor", icon: UserCheck, roles: ["direktur", "finance", "site_admin", "hr"] },
      { to: "/reports/payroll", label: "Rekap Payroll", icon: FileSpreadsheet, roles: ["direktur", "finance", "viewer"] },
      { to: "/reports/project", label: "Rekap Per Proyek", icon: FolderKanban, roles: ["direktur", "finance", "viewer"] },
      { to: "/reports/attendance", label: "Laporan Absensi", icon: ClipboardList, roles: ["direktur", "finance", "viewer"] },
      { to: "/reports/overtime", label: "Laporan Lembur", icon: Clock, roles: ["direktur", "finance", "viewer"] },
      { to: "/reports/overtime-high", label: "Lembur Tinggi", icon: Timer, roles: ["direktur", "finance", "hr", "site_admin"] },
      { to: "/reports/kasbon", label: "Laporan Kasbon", icon: PiggyBank, roles: ["direktur", "finance", "viewer"] },
    ],
  },
  {
    title: "NOTA BELANJA",
    items: [
      { to: "/nota", label: "Nota Belanja", icon: ShoppingCart, roles: ["finance", "direktur", "site_admin", "hr"] },
      { to: "/nota/persetujuan", label: "Persetujuan Nota Belanja", icon: FileCheck, roles: ["super_admin"] },
      { to: "/nota/rekap", label: "Rekap Belanja Bulanan", icon: BarChart3, roles: ["super_admin"] },
    ],
  },
  {
    title: "KENDARAAN",
    items: [
      { to: "/vehicles", label: "Perawatan Kendaraan", icon: CarFront, roles: ["finance", "direktur", "site_admin", "hr"] },
    ],
  },
  {
    title: "SISTEM",
    items: [
      { to: "/users", label: "Pengguna & Akses", icon: UserCog, roles: ["super_admin"] },
      { to: "/audit-logs", label: "Audit Log", icon: ScrollText, roles: ["super_admin", "direktur"] },
      { to: "/settings", label: "Pengaturan", icon: Settings, roles: ["super_admin"] },
    ],
  },
];

// Peta hak akses per route untuk penjaga routing (mirror menu di atas)
export const ROUTE_ROLES = {
  "/": ["direktur", "finance", "viewer"],
  "/employees": ["hr", "finance", "direktur", "site_admin"],
  "/salary-rates": ["finance", "direktur"],
  "/projects": ["hr", "finance", "direktur"],
  "/allowance-types": ["finance", "direktur"],
  "/attendance": ["hr", "site_admin", "direktur"],
  "/cash-advances": ["finance", "direktur"],
  "/kasbon-requests": ["site_admin", "finance", "direktur", "hr"],
  "/allowances": ["direktur"],
  "/deductions": ["direktur"],
  "/payroll": ["finance", "direktur"],
  "/payroll-history": ["finance", "direktur"],
  "/payments": ["finance", "direktur"],
  "/payslips": ["finance", "direktur"],
  "/nota": ["finance", "direktur", "site_admin", "hr"],
  "/nota/persetujuan": ["super_admin"],
  "/nota/rekap": ["super_admin"],
  "/vehicles": ["finance", "direktur", "site_admin", "hr"],
  "/reports/attendance-realtime": ["direktur", "finance", "site_admin", "viewer"],
  "/reports/attendance-range": ["direktur", "finance", "site_admin", "viewer"],
  "/reports/mandor-check": ["direktur", "finance", "site_admin", "hr"],
  "/reports/payroll": ["direktur", "finance", "viewer"],
  "/reports/project": ["direktur", "finance", "viewer"],
  "/reports/attendance": ["direktur", "finance", "viewer"],
  "/reports/overtime": ["direktur", "finance", "viewer"],
  "/reports/overtime-high": ["direktur", "finance", "hr", "site_admin"],
  "/reports/kasbon": ["direktur", "finance", "viewer"],
  "/users": ["super_admin"],
  "/audit-logs": ["super_admin", "direktur"],
  "/settings": ["super_admin"],
};

export const NOT_GRANTABLE = ["/users", "/settings", "/nota/persetujuan", "/nota/rekap"];

export function canAccess(roles, userRole, extraMenus, path) {
  if (userRole === "super_admin") return true;
  if (!roles || roles.length === 0) return true;
  if (roles.includes(userRole)) return true;
  return !!path && !NOT_GRANTABLE.includes(path) && (extraMenus || []).includes(path);
}

// Halaman awal berdasarkan peran
export function landingPath(role) {
  if (role === "site_admin") return "/attendance";
  if (role === "hr") return "/employees";
  return "/";
}
